import { Stack, StackProps } from '@mui/material'
import {
  DateRangeCalendarProps,
  DateRangeCalendar as MuiDateRangeCalendar
} from '@mui/x-date-pickers-pro'
import { unifiedColors } from 'styles/colors'
import { styled } from 'styles/styled'
import { themeUtils } from 'styles/theme'

export const DateTabContainer = styled((props: StackProps) => (
  <Stack
    width="100%"
    height="100%"
    justifyContent="center"
    padding="12px 8px"
    gap={2}
    {...props}
  />
))`
  ${themeUtils.maxWidth.md} {
    padding: 0 16px 18px;
    justify-content: space-between;
    width: auto;
  }
`

export const DateRangeCalendar = styled((props: DateRangeCalendarProps) => (
  <MuiDateRangeCalendar
    {...props}
    slotProps={{
      calendarHeader: {
        sx: {
          padding: 0,
          paddingLeft: '8px',
          '& .MuiPickersCalendarHeader-label': {
            ...themeUtils.h5
          }
        }
      },
      day: {
        sx: {
          '& .MuiDateRangePickerDay-day': {
            width: '42px',
            height: '40px'
          },
          '&:last-of-type, &.MuiDateRangePickerDay-endOfMonth, &:last-of-type .MuiDateRangePickerDay-rangeIntervalDayPreview, & .MuiDateRangePickerDay-rangeIntervalDayPreviewEnd':
            {
              borderTopRightRadius: '12px',
              borderBottomRightRadius: '12px'
            },
          '&:first-of-type, &.MuiDateRangePickerDay-startOfMonth, &:first-of-type .MuiDateRangePickerDay-rangeIntervalDayPreview, & .MuiDateRangePickerDay-rangeIntervalDayPreviewStart':
            {
              borderTopLeftRadius: '12px',
              borderBottomLeftRadius: '12px'
            },
          '& .MuiPickersDay-root': {
            transform: 'scale(1.125)',
            borderRadius: '12px',
            '& .Mui-selected': {}
          },
          '&.MuiDateRangePickerDay-rangeIntervalDayHighlight:not(.MuiDateRangePickerDay-outsideCurrentMonth)':
            {
              backgroundColor: `${unifiedColors.button.tertiary.default}`
            }
        }
      }
    }}
  />
))`
  &.MuiDateRangeCalendar-root {
    width: 100%;

    & .MuiDayCalendar-header .MuiDayCalendar-weekDayLabel {
      width: 42px;
      height: 40px;
    }
    & .MuiPickersSlideTransition-root {
      min-height: 280px;
    }
    & .MuiDateRangeCalendar-monthContainer {
      flex: 1;
      & .MuiTypography-root,
      & .MuiDateRangePickerDay-day {
        ${themeUtils.body}
        font-size: 14px;
        line-height: 1.2;
        color: ${unifiedColors.label.default};
      }

      & .MuiDateRangePickerDay-day {
        &.MuiPickersDay-today {
          &:not(.MuiDateRangePickerDay-dayInsideRangeInterval):not(
              .Mui-selected
            ) {
            border: 2px solid ${unifiedColors.border.default};
            background-color: transparent;
          }
          &.MuiDateRangePickerDay-dayInsideRangeInterval:not(.Mui-selected) {
            border: 1px solid ${unifiedColors.label.subduedDark};
          }
        }
        &.Mui-selected {
          color: ${unifiedColors.surface.default};
          &:hover {
            border: none;
          }
        }

        &.MuiDateRangePickerDay-dayOutsideRangeInterval:hover:not(
            .Mui-selected
          ) {
          border: 2px solid ${unifiedColors.surface.tertiary};
          background-color: ${unifiedColors.surface.secondary};
        }
      }
      & .MuiTypography-root {
        text-transform: capitalize;
        color: ${unifiedColors.label.subdued};
      }
      & .MuiPickersArrowSwitcher-root {
        padding: 0 8px;
        & .MuiTypography-root {
          ${themeUtils.h5}
        }
      }
    }

    ${themeUtils.maxWidth.sm} {
      width: auto;
    }
  }
`

export const ButtonsContainer = styled((props: StackProps) => (
  <Stack
    width="100%"
    justifyContent="flex-end"
    alignItems="center"
    flexDirection="row"
    {...props}
  />
))`
  & > div {
    ${themeUtils.maxWidth.md} {
      flex: unset;
      width: auto;
    }
    ${themeUtils.maxWidth.sm} {
      justify-content: unset;
      width: auto;
      flex: 1;
    }
  }
`
